import { DisclosureButton } from "@headlessui/react";
import React from "react";
import { useLocation } from "react-router-dom";

interface MobileMenuButtonProps {
    text: string; // The text to display for the link
    onClick: () => void; // The routing function to execute when the link is clicked
    isActivePath?: string[]; // The path to check if the link is active
    notificationBatch?: boolean
}

const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ text, onClick, isActivePath, notificationBatch = false }) => {
    const location = useLocation();



    // Check if the current path matches the active path
    const isActive = isActivePath && isActivePath.some(path => location.pathname.includes(path));

    return (
        <DisclosureButton
            as="a"
            onClick={onClick}
            className={`block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800 sm:px-6`}
        >
            {text}
        </DisclosureButton>
    );
};

export default MobileMenuButton;